var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRecruitNotebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 311.932,
    height: 187.408,
    viewBox: "0 0 311.932 187.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_recruit_notebook_icon",
    transform: "translate(0.5 0.5)",
    opacity: 0.397
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154495",
    "data-name": "\\uC0AC\\uAC01\\uD615 154495",
    width: 288.382,
    height: 160.18,
    rx: 5.602,
    transform: "translate(11.275)",
    fill: "#1876d2",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154496",
    "data-name": "\\uC0AC\\uAC01\\uD615 154496",
    width: 268.67,
    height: 131.234,
    transform: "translate(21.131 14.473)",
    fill: "#1876d2",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154497",
    "data-name": "\\uC0AC\\uAC01\\uD615 154497",
    d: "M0,0H310.932a0,0,0,0,1,0,0V14.805a5.345,5.345,0,0,1-5.345,5.345H5.345A5.345,5.345,0,0,1,0,14.805V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 166.258)",
    fill: "#1876d2",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154498",
    "data-name": "\\uC0AC\\uAC01\\uD615 154498",
    width: 213.944,
    height: 10.062,
    transform: "translate(46.632 155.632)",
    fill: "#1876d2",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154499",
    "data-name": "\\uC0AC\\uAC01\\uD615 154499",
    width: 80.474,
    height: 10.075,
    transform: "translate(115.229 166.258)",
    fill: "#1876d2",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_1678",
    "data-name": "\\uC120 1678",
    y2: 10.075,
    transform: "translate(156.013 166.258)",
    fill: "#ef4136",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileRecruitNotebookIcon);
export default __webpack_public_path__ + "static/media/mobile_recruit_notebook_icon.ffe3cf073de5d71419e2fb229ec71c09.svg";
export { ForwardRef as ReactComponent };